import { useRef } from 'react'

const BodyCell = ({children, classStyle, data_atr, sticky_items}) => {
    const cellRef = useRef(null)

    const leftPosition = (() => {
        if (!data_atr) return null;
        const isStickyCell =
            typeof classStyle === "string" && classStyle.includes("table-cell-sticky");
        if (sticky_items && sticky_items.length) {
            const foundItem = sticky_items.find((item) => item.index == data_atr);
            if (foundItem) return foundItem.left;
        }
        if (isStickyCell) {
            return `var(--wq-sticky-${data_atr}, 0px)`;
        }
        return null;
    })();

    function focusFirstEditableControl() {
        const root = cellRef.current
        if (!root) return

        // Prefer focusing real text inputs (CustomSelect / inputs / datepickers).
        const focusableInput = root.querySelector(
            'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])',
        )
        if (focusableInput && typeof focusableInput.focus === 'function') {
            focusableInput.focus()
            return
        }

        // Fallback: focus/click the first enabled button (CustomSelect openers).
        const btn = root.querySelector('button:not([disabled])')
        if (btn) {
            btn.click?.()
            btn.focus?.()
        }
    }

    function clickHandler(event) {
        // If user clicked a real interactive element, don't interfere.
        const interactive = event.target?.closest?.(
            'button, a, input, textarea, select, label, [role="button"], [data-workq-select-shell="true"]',
        )
        if (interactive) {
            return
        }
        focusFirstEditableControl()
    }

    // old code
    // const [leftPosition, setLeftPosition] = useState(null)

    // useEffect(() => {
    //     if (sticky_items && data_atr) {
    //         let foundItem = sticky_items.find(item => item.index == data_atr)

    //         if (foundItem) {
    //             setLeftPosition(foundItem.left)
    //         }
    //     }
    // }, [sticky_items, data_atr])


    
    return <td ref={cellRef} onClick={clickHandler} className={`${classStyle ? classStyle : ''}`} data-index={data_atr} style={{left: leftPosition}}>
        {children}
    </td>
}

export default BodyCell